import styled from "@emotion/styled";
import { Button, ButtonGroup } from "@mui/material";

export const FloatingBarContainer = styled.div(({ theme }) => ({
	position: "fixed",
	left: 0,
	right: 0,
	bottom: 0,

	backgroundColor: theme.project.colors.backgroundColors.main,
	borderTop: theme.project.borders.presets.outline,

	padding: "16px 16px",

	zIndex: 5,
	marginLeft: 248,
	[theme.breakpoints.down("lg")]: {
		margin: 0
	},
	display: "flex"
}));

export const FloatingButtonRow = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	gap: "16px",
	width: "100%",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		margin: "16px 0 0 0"
	}
}));

export const FloatingButtonGroup = styled(ButtonGroup)({
	gap: "16px"
});
export const EmptyCartButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.semanticColors.error,
	textTransform: "uppercase",
	borderColor: theme.project.colors.semanticColors.error,
	display: "flex",
	alignItems: "center"
}));
